import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_method_details: {
    title: '{{orderMethod}} over {{waitingTime}} min',
  },
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Bezorging',
    [ORDER_METHODS.PICKUP]: 'Afhalen',
    [ORDER_METHODS.ON_SITE]: 'Bestellen aan tafel',
  },
};
